import { createContext } from 'react';

const NONE_CONTEXT = {
    floatingUiActive: false,
};
const FloatingUiTrialContext = createContext(NONE_CONTEXT);

export { FloatingUiTrialContext as default };
